<template>
  <div>
    <!-- Create Follow-up Modal -->
    <modal v-show="isCreateModalVisible" @close="closeCreateModal" modalIsLarge footer>
      <template v-slot:title>
        <h5>Create Follow Up Record</h5>
      </template>
      <template v-slot:body>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Parent Full Name <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="createForm.parent_full_name"
                placeholder="Parent full name"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Telephone No <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="createForm.telephone"
                placeholder="Telephone number"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Kids Name <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="createForm.kids_name"
                placeholder="Kid's name"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Gender (Optional)</label>
              <select class="form-control" v-model="createForm.gender">
                <option value="">Select gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Kiddies NIN (Optional)</label>
              <input
                type="text"
                class="form-control"
                v-model="createForm.kiddies_nin"
                placeholder="Kiddies NIN"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Parents BVN (Optional)</label>
              <input
                type="text"
                class="form-control"
                v-model="createForm.parent_bvn"
                placeholder="Parent BVN"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Address (Optional)</label>
              <textarea
                class="form-control"
                v-model="createForm.address"
                rows="2"
                placeholder="Address"
              ></textarea>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-primary"
          @click="createFollowUp"
          :disabled="createLoading || !canCreateFollowUp"
        >
          <span v-if="createLoading">Saving...</span>
          <span v-else>Create Record</span>
        </button>
        <button @click.prevent="closeCreateModal" class="btn btn-secondary">
          Close
        </button>
      </template>
    </modal>

    <!-- View Follow-up Modal -->
    <modal v-show="isViewModalVisible" @close="closeViewModal" modalIsLarge footer>
      <template v-slot:title>
        <h5>Follow Up — {{ viewRecord.kids_name || "Record" }}</h5>
      </template>
      <template v-slot:body>
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: viewModalTab === 'overview' }"
              @click="viewModalTab = 'overview'"
              >Overview</a
            >
          </li>
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              class="nav-link"
              :class="{ active: viewModalTab === 'notes' }"
              @click="viewModalTab = 'notes'"
              >Notes</a
            >
          </li>
        </ul>

        <div v-if="viewModalTab === 'overview'">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Reference</label>
                <input type="text" class="form-control" :value="viewRecord.reference" disabled />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Status</label>
                <select
                  class="form-control"
                  v-model="viewRecord.status"
                  :disabled="!canCreateFollowUp || statusLoading"
                  @change="updateFollowUpStatus"
                >
                  <option value="open">Open</option>
                  <option value="contacted">Contacted</option>
                  <option value="converted">Converted</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Parent Full Name</label>
                <input
                  type="text"
                  class="form-control"
                  :value="viewRecord.parent_full_name"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Telephone No</label>
                <input type="text" class="form-control" :value="viewRecord.telephone" disabled />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Kids Name</label>
                <input type="text" class="form-control" :value="viewRecord.kids_name" disabled />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Gender</label>
                <input
                  type="text"
                  class="form-control"
                  :value="viewRecord.gender || 'N/A'"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Kiddies NIN</label>
                <input
                  type="text"
                  class="form-control"
                  :value="viewRecord.kiddies_nin || 'N/A'"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Parents BVN</label>
                <input
                  type="text"
                  class="form-control"
                  :value="viewRecord.parent_bvn || 'N/A'"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Address</label>
                <textarea
                  class="form-control"
                  :value="viewRecord.address || 'N/A'"
                  rows="2"
                  disabled
                ></textarea>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Created By</label>
                <input
                  type="text"
                  class="form-control"
                  :value="
                    viewRecord.created_by
                      ? viewRecord.created_by.full_name
                      : 'N/A'
                  "
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Created At</label>
                <input
                  type="text"
                  class="form-control"
                  :value="
                    viewRecord.created_at
                      ? new Date(viewRecord.created_at).toLocaleString()
                      : 'N/A'
                  "
                  disabled
                />
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div
            class="mb-3"
            v-if="canCreateFollowUp"
          >
            <div class="form-group">
              <label>Add Note</label>
              <textarea
                class="form-control"
                v-model="noteText"
                rows="3"
                placeholder="Write a note..."
              ></textarea>
            </div>
            <button
              class="btn btn-primary btn-sm"
              @click="addFollowUpNote"
              :disabled="noteLoading || !noteText.trim()"
            >
              <span v-if="noteLoading">Saving...</span>
              <span v-else>Add Note</span>
            </button>
          </div>

          <div v-if="!(viewRecord.notes || []).length" class="text-muted">
            No notes yet.
          </div>
          <div
            v-for="(item, index) in viewRecord.notes || []"
            :key="index"
            class="border rounded p-3 mb-2"
          >
            <p class="mb-1" style="white-space: pre-wrap;">{{ item.note }}</p>
            <small class="text-muted">
              {{ item.created_by || "Unknown" }}
              ·
              {{
                item.created_at
                  ? new Date(item.created_at).toLocaleString()
                  : ""
              }}
            </small>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button @click.prevent="closeViewModal" class="btn btn-secondary">
          Close
        </button>
      </template>
    </modal>

    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>{{ pageLoadingMessage }}</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h3 class="mb-2 font-regular">Kiddies Account</h3>
        </div>
        <div class="col-auto">
          <button
            v-if="activeTab === 'follow-up' && canCreateFollowUp"
            class="btn btn-primary"
            @click="openCreateModal"
          >
            Create Record
          </button>
        </div>
      </div>

      <ul class="nav nav-tabs mb-4">
        <li class="nav-item">
          <a
            href="javascript:void(0)"
            class="nav-link"
            :class="{ active: activeTab === 'accounts' }"
            @click="switchTab('accounts')"
            >Accounts</a
          >
        </li>
        <li class="nav-item" v-if="canViewFollowUp">
          <a
            href="javascript:void(0)"
            class="nav-link"
            :class="{ active: activeTab === 'follow-up' }"
            @click="switchTab('follow-up')"
            >Follow Up</a
          >
        </li>
      </ul>

      <div v-if="activeTab === 'accounts'">
        <div class="row align-items-end mb-3">
          <div class="col-md-3 col-12">
            <div class="form-group">
              <label>Name</label>
              <input
                type="text"
                class="form-control"
                v-model="accountName"
                placeholder="Child name"
                @keyup.enter="getAds(1)"
              />
            </div>
          </div>
          <div class="col-md-2 col-12">
            <div class="form-group">
              <label>Account Number</label>
              <input
                type="text"
                class="form-control"
                v-model="accountNumber"
                placeholder="Account number"
                @keyup.enter="getAds(1)"
              />
            </div>
          </div>
          <div class="col-md-2 col-12">
            <div class="form-group">
              <label>Status</label>
              <select class="form-control" v-model="accountStatus">
                <option value="">All</option>
                <option value="initiated">Initiated</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
            </div>
          </div>
          <div class="col-md-2 col-12">
            <div class="form-group">
              <label>Created From</label>
              <input type="date" class="form-control" v-model="accountDateFrom" />
            </div>
          </div>
          <div class="col-md-2 col-12">
            <div class="form-group">
              <label>Created To</label>
              <input type="date" class="form-control" v-model="accountDateTo" />
            </div>
          </div>
          <div class="col-auto">
            <button class="btn btn-secondary mb-3 me-2" @click.prevent="getAds(1)">
              Filter
            </button>
            <button
              class="btn btn-primary mb-3"
              @click.prevent="exportAccounts"
              :disabled="exportLoading"
            >
              <span v-if="exportLoading">Exporting...</span>
              <span v-else>Export CSV</span>
            </button>
          </div>
        </div>

        <div class="card card--no-shadow">
          <div class="card-content">
            <div class="card-body">
              <CDataTable :items="arr" :fields="fields" sorter tableFilter>
                <template #guardian="{ item }">
                  <td class="table--action-mobile">
                    {{
                      item.user
                        ? item.user.first_name + " " + item.user.last_name
                        : "N/A"
                    }}
                  </td>
                </template>
                <template #guardian_bvn="{ item }">
                  <td class="table--action-mobile">
                    {{ item.guardian_bvn || "N/A" }}
                  </td>
                </template>
                <template #guardian_account_numbers="{ item }">
                  <td class="table--action-mobile guardian-accounts">
                    <span v-if="guardianAccountNumbers(item)">{{
                      guardianAccountNumbers(item)
                    }}</span>
                    <span v-else>N/A</span>
                  </td>
                </template>
                <template #name="{ item }">
                  <td class="table--action-mobile">
                    {{
                      item.user
                        ? item.first_name + " " + item.last_name
                        : "N/A"
                    }}
                  </td>
                </template>
                <template #account_number="{ item }">
                  <td class="table--action-mobile">
                    <span v-if="kiddiesAccountNumber(item)">{{
                      kiddiesAccountNumber(item)
                    }}</span>
                    <em v-else>no account yet</em>
                  </td>
                </template>
                <template #created_at="{ item }">
                  <td class="table--action-mobile">
                    {{ new Date(item.created_at).toLocaleString() }}
                  </td>
                </template>
                <template #actions="{ item }">
                  <td class="table--action-mobile d-flex border-0">
                    <button
                      class="btn btn-secondary me-2"
                      @click.prevent="viewKiddies(item)"
                    >
                      View
                    </button>
                  </td>
                </template>
              </CDataTable>
              <CPagination
                :activePage.sync="next_page"
                :pages="total"
                :onActivePageChange="onPageChange()"
              ></CPagination>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="activeTab === 'follow-up' && canViewFollowUp">
        <div class="row align-items-end mb-3">
          <div class="col-md-3 col-12">
            <div class="form-group">
              <label>Status</label>
              <select class="form-control" v-model="followUpStatusFilter">
                <option value="">All</option>
                <option value="open">Open</option>
                <option value="contacted">Contacted</option>
                <option value="converted">Converted</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="form-group">
              <label>Search</label>
              <input
                type="text"
                class="form-control"
                v-model="followUpSearch"
                placeholder="Parent, kid, phone, reference"
              />
            </div>
          </div>
          <div class="col-auto">
            <button class="btn btn-secondary mb-3" @click.prevent="getFollowUps(1)">
              Filter
            </button>
          </div>
        </div>

        <div class="card card--no-shadow">
          <div class="card-content">
            <div class="card-body">
              <CDataTable
                :items="followUps"
                :fields="followUpFields"
                sorter
                tableFilter
              >
                <template #status="{ item }">
                  <td class="table--action-mobile">
                    <span
                      class="badge"
                      :class="{
                        'badge-warning': item.status === 'open',
                        'badge-info': item.status === 'contacted',
                        'badge-success': item.status === 'converted',
                      }"
                    >
                      {{ item.status }}
                    </span>
                  </td>
                </template>
                <template #created_at="{ item }">
                  <td class="table--action-mobile">
                    {{ new Date(item.created_at).toLocaleString() }}
                  </td>
                </template>
                <template #actions="{ item }">
                  <td class="table--action-mobile d-flex border-0">
                    <button
                      class="btn btn-secondary me-2"
                      @click.prevent="openViewModal(item)"
                    >
                      View
                    </button>
                  </td>
                </template>
              </CDataTable>
              <CPagination
                :activePage.sync="followUpNextPage"
                :pages="followUpTotal"
                :onActivePageChange="onFollowUpPageChange()"
              ></CPagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CPagination from "../../components/CPagination.vue";
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";

const fields = [
  "name",
  { key: "account_number", label: "Kiddies Account" },
  "nin",
  "guardian",
  { key: "guardian_bvn", label: "Guardian BVN" },
  { key: "guardian_account_numbers", label: "Guardian Account" },
  "status",
  "created_at",
  "actions",
];
const followUpFields = [
  "reference",
  "parent_full_name",
  "kids_name",
  "telephone",
  "status",
  "created_at",
  "actions",
];

const emptyCreateForm = () => ({
  parent_full_name: "",
  address: "",
  kiddies_nin: "",
  parent_bvn: "",
  telephone: "",
  kids_name: "",
  gender: "",
});

export default {
  name: "KiddiesAccount",
  components: {
    CDataTable,
    CPagination,
  },
  data() {
    return {
      fields,
      followUpFields,
      activeTab: "accounts",
      pageLoadingMessage: "Getting Account Request ready...",
      pageLoading: true,
      loading: false,
      arr: [],
      current: 1,
      next_page: 1,
      total: 1,
      accountName: "",
      accountNumber: "",
      accountStatus: "",
      accountDateFrom: "",
      accountDateTo: "",
      exportLoading: false,
      followUps: [],
      followUpCurrent: 1,
      followUpNextPage: 1,
      followUpTotal: 1,
      followUpStatusFilter: "",
      followUpSearch: "",
      isCreateModalVisible: false,
      isViewModalVisible: false,
      createForm: emptyCreateForm(),
      createLoading: false,
      viewRecord: {},
      viewModalTab: "overview",
      noteText: "",
      noteLoading: false,
      statusLoading: false,
    };
  },
  computed: {
    permissions() {
      return this.$store.getters.permissions || [];
    },
    canViewFollowUp() {
      return this.permissions.includes("kiddies-follow-up");
    },
    canCreateFollowUp() {
      return this.permissions.includes("create-kiddies-follow-up");
    },
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
      if (tab === "follow-up" && this.canViewFollowUp) {
        this.getFollowUps(1);
      }
    },
    accountQuery(page) {
      const params = new URLSearchParams();
      if (page) {
        params.append("page", String(page));
      }
      if (this.accountName) {
        params.append("name", this.accountName.trim());
      }
      if (this.accountNumber) {
        params.append("account_number", this.accountNumber.trim());
      }
      if (this.accountStatus) {
        params.append("status", this.accountStatus);
      }
      if (this.accountDateFrom) {
        params.append("date_from", this.accountDateFrom);
      }
      if (this.accountDateTo) {
        params.append("date_to", this.accountDateTo);
      }
      return params;
    },
    kiddiesAccountNumber(item) {
      if (item.account_number) {
        return item.account_number;
      }
      if (item.account && item.account.account_number) {
        return item.account.account_number;
      }
      return "";
    },
    guardianAccountNumbers(item) {
      const numbers = Array.isArray(item.guardian_account_numbers)
        ? item.guardian_account_numbers
        : [];
      return numbers.filter(Boolean).join("\n");
    },
    async getAds(page) {
      this.pageLoading = true;
      this.pageLoadingMessage = `Getting Account Request ready...`;

      try {
        const params = this.accountQuery(page);
        const res = await ApiService.get(
          `account/kiddies_accounts?${params.toString()}`
        );
        this.arr = res.data.data.data;
        this.current = res.data.data.current_page;
        this.total = res.data.data.last_page;
        this.next_page = this.current;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        console.log(error);
      }
    },
    async exportAccounts() {
      this.exportLoading = true;
      try {
        ApiService.setHeader();
        const params = this.accountQuery();
        const query = params.toString();
        const res = await ApiService.customRequest({
          method: "get",
          url: `account/kiddies_accounts/export${query ? `?${query}` : ""}`,
          responseType: "blob",
        });

        const blob = new Blob([res.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        const stamp = new Date().toISOString().slice(0, 10);
        link.href = url;
        link.setAttribute("download", `kiddies_accounts_${stamp}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.exportLoading = false;
      } catch (error) {
        this.exportLoading = false;
        ErrorService.displayErrorAlert(error);
      }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        this.getAds(this.next_page);
      }
    },
    viewKiddies(item) {
      const ref = item.reference || item.slug || item.id || item.account_number;
      if (!ref) {
        return Swal.fire({
          icon: "error",
          title: "Error",
          text: "No reference available for this account",
        });
      }
      this.$router.push({ path: `/kiddies/${ref}` });
    },
    async getFollowUps(page) {
      if (!this.canViewFollowUp) {
        return;
      }

      this.pageLoading = true;
      this.pageLoadingMessage = "Getting Follow Up records...";

      try {
        const params = new URLSearchParams({ page: String(page) });
        if (this.followUpStatusFilter) {
          params.append("status", this.followUpStatusFilter);
        }
        if (this.followUpSearch) {
          params.append("search", this.followUpSearch);
        }

        const res = await ApiService.get(
          `account/kiddies_follow_ups?${params.toString()}`
        );
        this.followUps = res.data.data.data;
        this.followUpCurrent = res.data.data.current_page;
        this.followUpTotal = res.data.data.last_page;
        this.followUpNextPage = this.followUpCurrent;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        ErrorService.displayErrorAlert(error);
      }
    },
    onFollowUpPageChange() {
      if (this.followUpCurrent != this.followUpNextPage) {
        this.getFollowUps(this.followUpNextPage);
      }
    },
    openCreateModal() {
      this.createForm = emptyCreateForm();
      this.isCreateModalVisible = true;
    },
    closeCreateModal() {
      this.isCreateModalVisible = false;
    },
    async createFollowUp() {
      if (!this.createForm.parent_full_name || !this.createForm.telephone || !this.createForm.kids_name) {
        return Swal.fire({
          icon: "warning",
          title: "Missing fields",
          text: "Parent full name, telephone, and kids name are required.",
        });
      }

      this.createLoading = true;
      try {
        const payload = { ...this.createForm };
        if (!payload.gender) delete payload.gender;
        if (!payload.address) delete payload.address;
        if (!payload.kiddies_nin) delete payload.kiddies_nin;
        if (!payload.parent_bvn) delete payload.parent_bvn;

        await ApiService.post("account/kiddies_follow_ups", payload);
        this.createLoading = false;
        this.closeCreateModal();
        this.getFollowUps(1);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Follow-up record created successfully",
        });
      } catch (error) {
        this.createLoading = false;
        ErrorService.displayErrorAlert(error);
      }
    },
    openViewModal(item) {
      this.viewRecord = Object.assign({}, item, {
        notes: item.notes || [],
      });
      this.viewModalTab = "overview";
      this.noteText = "";
      this.isViewModalVisible = true;
    },
    closeViewModal() {
      this.isViewModalVisible = false;
      this.viewRecord = {};
      this.noteText = "";
    },
    async updateFollowUpStatus() {
      if (!this.viewRecord.reference || !this.canCreateFollowUp) {
        return;
      }

      this.statusLoading = true;
      try {
        const res = await ApiService.post(
          `account/kiddies_follow_ups/${this.viewRecord.reference}/status`,
          { status: this.viewRecord.status }
        );
        this.viewRecord = Object.assign({}, res.data.data, {
          notes: res.data.data.notes || [],
        });
        this.statusLoading = false;
        this.getFollowUps(this.followUpCurrent || 1);
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: "Status updated successfully",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        this.statusLoading = false;
        ErrorService.displayErrorAlert(error);
        this.getFollowUps(this.followUpCurrent || 1);
      }
    },
    async addFollowUpNote() {
      if (!this.noteText.trim() || !this.viewRecord.reference) {
        return;
      }

      this.noteLoading = true;
      try {
        const res = await ApiService.post(
          `account/kiddies_follow_ups/${this.viewRecord.reference}/notes`,
          { note: this.noteText.trim() }
        );
        this.viewRecord = Object.assign({}, res.data.data, {
          notes: res.data.data.notes || [],
        });
        this.noteText = "";
        this.noteLoading = false;
        Swal.fire({
          icon: "success",
          title: "Note added",
          timer: 1200,
          showConfirmButton: false,
        });
      } catch (error) {
        this.noteLoading = false;
        ErrorService.displayErrorAlert(error);
      }
    },
  },
  mounted() {
    this.getAds(1);
  },
};
</script>

<style scoped>
.guardian-accounts {
  white-space: pre-line;
}
</style>
